import { createSelector } from 'reselect'

import { selectStrategicInitiativesState } from './selectStrategicInitiativesState'

export const selectStrategicInitiativesSelectedRtm = createSelector(
  [selectStrategicInitiativesState],
  (state) => state.selectedRtm
)
